import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

// The idea for use canvas to compress is steal from squoosh :D
// https://github.com/GoogleChromeLabs/squoosh/blob/dev/src/client/lazy-app/util/canvas.ts
function canvasEncode(_x, _x2, _x3) {
  return _canvasEncode.apply(this, arguments);
}

function _canvasEncode() {
  _canvasEncode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data, type, quality) {
    var canvas, ctx, blob, dataUrl, result, outputType, binaryStr, outData, i;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          canvas = document.createElement('canvas');
          canvas.width = data.width;
          canvas.height = data.height;
          ctx = canvas.getContext('2d');

          if (ctx) {
            _context2.next = 6;
            break;
          }

          throw Error('Canvas not initialized');

        case 6:
          ctx.putImageData(data, 0, 0);

          if (!('toBlob' in canvas)) {
            _context2.next = 13;
            break;
          }

          _context2.next = 10;
          return new Promise(function (r) {
            return canvas.toBlob(r, type, quality);
          });

        case 10:
          blob = _context2.sent;
          _context2.next = 22;
          break;

        case 13:
          // Welcome to Edge.
          // TypeScript thinks `canvas` is 'never', so it needs casting.
          dataUrl = canvas.toDataURL(type, quality);
          result = /data:([^;]+);base64,(.*)$/.exec(dataUrl);

          if (result) {
            _context2.next = 17;
            break;
          }

          throw Error('Data URL reading failed');

        case 17:
          outputType = result[1];
          binaryStr = atob(result[2]);
          outData = new Uint8Array(binaryStr.length);

          for (i = 0; i < outData.length; i += 1) {
            outData[i] = binaryStr.charCodeAt(i);
          }

          blob = new Blob([outData], {
            type: outputType
          });

        case 22:
          if (blob) {
            _context2.next = 24;
            break;
          }

          throw Error('Encoding failed');

        case 24:
          return _context2.abrupt("return", blob);

        case 25:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _canvasEncode.apply(this, arguments);
}

function builtinCompressResize(image, maxWidth) {
  var canvas = document.createElement('canvas');
  var scaleFactor = maxWidth / image.width;
  if (scaleFactor > 1) scaleFactor = 1;
  var transformWidth = Math.max(Math.round(image.width * scaleFactor), 1);
  var transformHeight = Math.max(Math.round(image.height * scaleFactor), 1);
  canvas.width = transformWidth;
  canvas.height = transformHeight;
  var ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Could not create canvas context');
  ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, transformWidth, transformHeight);
  return ctx.getImageData(0, 0, transformWidth, transformHeight);
}

function blobToImage(blob) {
  var image = document.createElement('img');
  var imageUrl = URL.createObjectURL(blob);
  image.src = imageUrl;
  return new Promise(function (resolve, reject) {
    image.onerror = function () {
      reject(new Error('failed to create Image() from blob'));
    };

    image.onload = function () {
      resolve(image);
    };
  });
}

export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file, maxWidth) {
    var image, imageCompressedData, blob, filename, pos, newname;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return blobToImage(file);

        case 2:
          image = _context.sent;
          imageCompressedData = builtinCompressResize(image, maxWidth);
          _context.next = 6;
          return canvasEncode(imageCompressedData, 'image/jpeg');

        case 6:
          blob = _context.sent;
          filename = file.name;
          pos = filename.lastIndexOf('.');
          newname = "".concat(filename.substr(0, pos < 0 ? filename.length : pos), ".jpeg");
          return _context.abrupt("return", new File([blob], newname, {
            type: 'image/jpeg'
          }));

        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function (_x4, _x5) {
    return _ref.apply(this, arguments);
  };
})();
//# sourceMappingURL=compressImage.js.map